import { createSelector } from "@ngrx/store";
import { AppState } from "..";
import { AutoArchiveState } from "./auto-archive.reducers";

const featureSelector = (state: AppState) => state.autoArchive;

export const selectAutoArchiveRules = createSelector(
    featureSelector,
    (state: AutoArchiveState) => state.rules
);

export const selectAutoArchiveLoading = createSelector(
    featureSelector,
    (state: AutoArchiveState) => state.loading
);

export const selectAutoArchiveError = createSelector(
    featureSelector,
    (state: AutoArchiveState) => state.error
);

export const selectAutoArchiveRuleById = (id: number) =>
    createSelector(selectAutoArchiveRules, (rules) =>
        rules.find((rule) => rule.id === id)
    );
